export default __webpack_public_path__ + "static/media/regulatory--yield-or-stop-for-pedestrians--g1.bf8555de.png";